var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cm-card',{attrs:{"is-header-none":"","custom-class":"page-profile__card mt-4"}},[_c('personal-info',{attrs:{"email":_vm.getEmailUser}}),_c('update-password')],1)}
var staticRenderFns = []

export { render, staticRenderFns }